// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see CashGreenCashGreenStatusFirstUnlockedEvent
 */
export var CashGreenCashGreenStatusFirstUnlocked = function (_a) {
    var customerToken = _a.customerToken, reason = _a.reason;
    return ({
        name: "CashGreen CashGreenStatus FirstUnlocked",
        parameters: {
            cdf_entity: "CashGreen",
            cdf_action: "CashGreenStatus",
            customer_token: customerToken !== undefined && customerToken !== null ? customerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            reason: reason !== undefined && reason !== null ? reason.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashGreenCashGreenStatusUnlockedEvent
 */
export var CashGreenCashGreenStatusUnlocked = function (_a) {
    var customerToken = _a.customerToken, reason = _a.reason;
    return ({
        name: "CashGreen CashGreenStatus Unlocked",
        parameters: {
            cdf_entity: "CashGreen",
            cdf_action: "CashGreenStatus",
            customer_token: customerToken !== undefined && customerToken !== null ? customerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            reason: reason !== undefined && reason !== null ? reason.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CashGreenCashGreenStatusExpiredEvent
 */
export var CashGreenCashGreenStatusExpired = function (_a) {
    var customerToken = _a.customerToken;
    return ({
        name: "CashGreen CashGreenStatus Expired",
        parameters: {
            cdf_entity: "CashGreen",
            cdf_action: "CashGreenStatus",
            customer_token: customerToken !== undefined && customerToken !== null ? customerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
